import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Hint({
  children,
  className,
  error,
  disabled,
  icon,
}) {
  return (
    <div className={classNames('hint', className, { 'hint-error': error, disabled })}>
      <i className={classNames('hint-icon', icon)} />
      {children}
    </div>
  );
}

Hint.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
};

Hint.defaultProps = {
  className: '',
  error: false,
  disabled: false,
  icon: 'ri-information-fill',
};

export default Hint;
